import { createSlice } from "@reduxjs/toolkit";
import { submitStudentFeedbackThunk } from "../thunks";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";

interface SubmitFeedbackState {
    isSubmitting: boolean;
    isSuccess: boolean;
    status: REQUEST_STATUS;
    error: string | null;
}

const initialState: SubmitFeedbackState = {
    isSubmitting: false,
    isSuccess: false,
    error: null,
    status: REQUEST_STATUS.IDLE,
};

const reportingSubmitFeedbackSlice = createSlice({
    name: "reporting/submitFeedback",
    initialState,
    reducers: {
        resetSubmitFeedbackState: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(submitStudentFeedbackThunk.pending, state => {
                state.isSubmitting = true;
                state.isSuccess = false;
                state.error = null;
                state.status = REQUEST_STATUS.PENDING;
            })
            .addCase(submitStudentFeedbackThunk.fulfilled, state => {
                state.isSubmitting = false;
                state.isSuccess = true;
                state.status = REQUEST_STATUS.SUCCESS;
            })
            .addCase(
                submitStudentFeedbackThunk.rejected,
                (state, { payload }) => {
                    state.isSubmitting = false;
                    state.isSuccess = false;
                    state.error = payload ?? "Unknown error";
                    state.status = REQUEST_STATUS.ERROR;
                }
            );
    }
});

export const { resetSubmitFeedbackState } =
    reportingSubmitFeedbackSlice.actions;
export default reportingSubmitFeedbackSlice.reducer;
